import { useMutation } from 'react-query';
import { notificationsService, removeCache } from '../../../services';
import { enqueueSnackbar } from '../../../design-system';
import { MESSAGES } from '../../../const';

export const useReadNotificationMutation = () => {
  return useMutation(
    (id: string) => {
      return notificationsService.read(id);
    },
    {
      onSuccess: () => {
        enqueueSnackbar(MESSAGES.NOTIFICATIONS.SUCCESS.READ, 'success');
        removeCache(['notifications']);
      },
      onError: () => {
        enqueueSnackbar(MESSAGES.NOTIFICATIONS.ERROR.NOT_READ, 'error');
      },
    },
  );
};

export const useDeleteNotificationMutation = () => {
  return useMutation(
    (id: string) => {
      return notificationsService.delete(id);
    },
    {
      onSuccess: () => {
        enqueueSnackbar(MESSAGES.NOTIFICATIONS.SUCCESS.DELETE, 'success');
        removeCache(['notifications']);
      },
      onError: () => {
        enqueueSnackbar(MESSAGES.NOTIFICATIONS.ERROR.NOT_DELETED, 'error');
      },
    },
  );
};
